export const createAuthApi = (customFetch) => ({
  logOut: async () => {
    try {
      const response = await customFetch('logOut', {
        method: "POST"
      });
      
      if (response) { // Теперь response уже разобранный JSON или null
        return response;
      }
      return null;
    } catch (error) {
      console.error("Error logging out:", error);
      return null;
    }
  }
});